import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewPNDataFormValues } from '@e-origin/contracts';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';

interface TSDPNPersonPresentingSectionProps {
  form: UseFormReturnType<TSDViewPNDataFormValues>;
  disabled: boolean;
}

export const TSDPNPersonPresentingSection: React.FC<TSDPNPersonPresentingSectionProps> = ({ form, disabled }) => {
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Person presenting the goods
      </Title>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.identificationNumber')} label="Identification number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.name')} label="Name" disabled={disabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.address.streetAndNumber')} label="Street and number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <MultiLangCodes
            {...form.getInputProps('personPresentingTheGoods.address.country')}
            label="Country"
            code="CL199"
            system={codelistSystems}
            disabled={disabled}
          />
        </Grid.Col>

        <Grid.Col span={2}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.address.postcode')} label="Post code" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.address.city')} label="City" disabled={disabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.communication.phoneNumber')} label="Phone number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={4}>
          <TextInput {...form.getInputProps('personPresentingTheGoods.communication.eMailAddress')} label="Email address" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
